import {UserFeature} from "../../features-api/models";

export enum ReportPresenterEvents {
    closeReport = 'reportPresenter:closeReport'
}

export interface ExtraProps {
    [key: string]: any;
}

export interface IReportPresenter {
    showReportById(id: string, requestEdit: boolean);
    showReport(report: any, extraProps?: ExtraProps);
    showReportForFeature(feature: UserFeature, requestEdit: boolean);
}
